import { resourceText } from 'src/app/shared/services/localization';
import { formatDate, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from 'src/app/tenant/tenant.service';
import { MemberSearch } from '../member-search/member-search.model';
import { MemberSearchService } from '../member-search/member-search.service';
import { AddFollowup } from '../models/addFollowup.model';
import { GetPlannedFollowup } from '../models/getPlannedFollowup.model';
import { member } from '../models/member.model';
import { MembersFollowup } from '../models/members-followup.model';
import { UpdatePlannedFollowup } from '../models/updateFollowup.model';
import { FollowupService } from '../services/followup.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';
import { MemberService } from '../services/member.service'; 

@Component({
    selector: 'app-user-task',
    templateUrl: './user-task.component.html',
    styleUrls: ['./user-task.component.scss'],
    standalone: false
})
export class UserTaskComponent implements OnInit, OnChanges {
  @Input() user: MemberSearch;
  @Input() plansArr: GetPlannedFollowup[];
  @Input() event: string;
  @Input() applyRefresh: boolean = false;
  isLoading: boolean = false;
  showOnMap: boolean = false;
  clusterOnMap: boolean = false;
  subdomain: string = '';
  searchText: string = '';
  completingTask: boolean = false;
  timeZone: number = -1;

  constructor(
    public globalService: GlobalService,
    public identityService: IdentityService,
    private memberService: MemberService,
    private _router: Router,
    public memberSearchService: MemberSearchService,
    private _location: Location,
    private tenantService: TenantService,
    private followupService: FollowupService,
    private changeDetectorRef: ChangeDetectorRef    
  ) {}
  
  async ngOnInit() {
      this.timeZone = this.globalService.timeZone;
  }

  ngOnChanges() {
    this.user['activity'] = this.GetActivityValue(this.event);
    this.user['activityStr'] = this.event;
    this.user['status'] = 1;
    this.user['actualDate'] = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.user['timeStr'] = formatDate(new Date(), 'HH:mm', 'en');
  }

  confirmAction(event) {
    if (event.type == event.user.activityStr || event.type == 'ALL') {
      this.user['confirmView'] = true;
      this.user['editView'] = false;
    }
  }

  GetActivityValue(event: string) {
    switch (event) {
      case 'Visit':
        return 0;
      case 'Call':
        return 1;
      case 'Text':
        return 2;
      case 'Email':
        return 3;
    }
    return -1;
  }

  async DefaultTask(user: MemberSearch) {
    if (this.plansArr && this.plansArr.length > 0) {
      let currentFollowup: GetPlannedFollowup = this.plansArr.filter(
        (x) => x.memberId == user.memberId
      )[0];
      let newRec: UpdatePlannedFollowup = new UpdatePlannedFollowup();
      newRec.id = currentFollowup.id;
      newRec.memberId = currentFollowup.memberId;
      newRec.activity = currentFollowup.activity;
      newRec.planDate = currentFollowup.planDate;
      newRec.actualDate = new Date(user['actualDate'].toString() + 'T' + user['timeStr'].toString());
      newRec.actualDate.setTime(newRec.actualDate.getTime() + ((-this.timeZone)*60*60*1000));      
      newRec.status = 1;
      newRec.assigner = currentFollowup.assigner;
      newRec.assignerComment = currentFollowup.assignerComment;
      newRec.assignee = this.identityService.memberId;
      newRec.assigneeComment = '';
      newRec.createdBy = currentFollowup.createdBy;
      newRec.creationDate = currentFollowup.creationDate;
      this.completingTask = true;
      await this.followupService.updateFollowup(newRec);
      let idx = this.plansArr.findIndex((a) => a.id == currentFollowup.id);
      this.plansArr.splice(idx, 1);
    } else {
      let membersFollowup: MembersFollowup = new MembersFollowup();
      let newRec: AddFollowup = new AddFollowup();
      newRec.memberId = user.memberId;
      newRec.activity = this.GetActivityValue(this.event);
      newRec.planDate = new Date();
      newRec.actualDate = new Date();
      newRec.status = 1;
      newRec.assigner = this.identityService.memberId;
      newRec.assignerComment = '';
      newRec.assignee = this.identityService.memberId;
      newRec.assigneeComment = '';
      newRec.createdBy =
        this.identityService.firstName + ' ' + this.identityService.lastName;
      newRec.creationDate = new Date();
      this.completingTask = true;
      membersFollowup.addFollowupDto = newRec;
      membersFollowup.assignees = [this.identityService.memberId];
      membersFollowup.memberIds = [this.user.memberId];
      await this.followupService.addFollowup(membersFollowup);
    }
    this.completingTask = false;
    this.user['confirmView'] = false;
    this.user['editView'] = false;
    if (this.applyRefresh)
      await this.loadTasks();
  }
 
  async CompleteTask(user: MemberSearch) {
    if (this.plansArr && this.plansArr.length > 0) {
      let newRec: UpdatePlannedFollowup = new UpdatePlannedFollowup();
      newRec.id = user['taskId'];
      newRec.memberId = user['memberId'];
      newRec.activity = user['activity'];
      newRec.planDate = new Date(user['planDate'].toString() + 'T' + user['timeStr'].toString());
      newRec.planDate.setTime(newRec.planDate.getTime() + ((-this.timeZone)*60*60*1000));
      newRec.actualDate = new Date(user['actualDate'].toString() + 'T' + user['timeStr'].toString());
      newRec.planDate.setTime(newRec.actualDate.getTime() + ((-this.timeZone)*60*60*1000));
      newRec.status = user['status'];
      newRec.assigner = user['assigner'];
      newRec.assignerComment = user['assignerComment'];
      newRec.assignee = user['assignee'];
      newRec.assigneeComment = user['assigneeComment'];
      newRec.createdBy = user['createdBy'];
      newRec.creationDate = new Date(user['creationDate']);
      newRec.creationDate.setTime(newRec.creationDate.getTime() + ((-this.timeZone)*60*60*1000));
      this.completingTask = true;
      await this.followupService.updateFollowup(newRec);
      let idx = this.plansArr.findIndex((a) => a.id == newRec.id);
      this.plansArr.splice(idx, 1);
    } else {
      let membersFollowup: MembersFollowup = new MembersFollowup();
      let newRec: AddFollowup = new AddFollowup();
      newRec.memberId = user['memberId'];
      newRec.activity = user['activity'];
      if (user['planDate'] === undefined)
        user['planDate'] = user['actualDate'];
      newRec.planDate = new Date(user['planDate']);
      newRec.planDate.setTime(newRec.planDate.getTime() + ((-this.timeZone)*60*60*1000));
      newRec.actualDate = new Date(user['actualDate'].toString() + 'T' + user['timeStr'].toString());
      newRec.planDate.setTime(newRec.actualDate.getTime() + ((-this.timeZone)*60*60*1000));
      newRec.status = user['status'];
      newRec.assigner = user['assigner'];
      newRec.assignerComment = user['assignerComment'];
      newRec.assignee = user['assignee'];
      newRec.assigneeComment = user['assigneeComment'];
      newRec.createdBy = user['createdBy'];
      if (user['creationDate'] === undefined)
        user['creationDate'] = user['actualDate'];      
      newRec.creationDate = new Date(user['creationDate']);
      newRec.creationDate.setTime(newRec.creationDate.getTime() + ((-this.timeZone)*60*60*1000));
      this.completingTask = true;
      membersFollowup.addFollowupDto = newRec;
      membersFollowup.assignees = [this.identityService.memberId];
      membersFollowup.memberIds = [this.user.memberId];
      await this.followupService.addFollowup(membersFollowup);
    }

    this.completingTask = false;
    this.user['confirmView'] = false;
    this.user['editView'] = false;
    if (this.applyRefresh)
      await this.loadTasks();
  }

  async loadTasks() {
    this.plansArr = await this.followupService.GetFollowupByAssignee(
      this.identityService.memberId
    );
    this.memberSearchService.searchResult =
      await this.memberSearchService.AdvancedSearch(
        this.memberSearchService.filter,
        'pageNumber=1&pageSize=20', true
      );
    this.populatePlans();
  }

  getRecordMessage(user){
    switch (user['activity']) {
      case 0:
        return resourceText('RECORD_VISIT');
      case 1:
        return resourceText('RECORD_CALL');
      case 2: 
        return resourceText('RECORD_TEXT');
      case 3:
          return resourceText('RECORD_EMAIL');
      default:
          user['activity'] = 1;
          return resourceText('RECORD_CALL')
  
    }
    return resourceText('RECORD')
  }
  
  populatePlans() {
    var members = this.plansArr.map(a => a.memberId);
    this.memberSearchService.memberArr = this.memberSearchService.memberArr.filter(a => members.findIndex(b => b == a.memberId)>=0);
    this.memberSearchService.memberArr.forEach((a) => {
      var plan = this.plansArr.filter((x) => x.memberId == a.memberId)[0];
      a['taskId'] = plan.id;
      a['confirmView'] = false;
      a['editView'] = false;
      a['activity'] = plan.activity;
      a['activityStr'] = plan.activityStr;
      a['planDate'] = formatDate(plan.planDate, 'yyyy-MM-dd', 'en');
      a['actualDate'] = formatDate(plan.actualDate, 'yyyy-MM-dd', 'en');
      a['assigner'] = plan.assigner;
      a['assignerComment'] = plan.assignerComment;
      a['assignee'] = plan.assignee;
      a['assigneeComment'] = plan.assigneeComment;
      a['status'] = 1;
      a['createdBy'] = plan.createdBy;
      a['creationDate'] = plan.creationDate;
      switch (plan.activityStr) {
        case 'Visit':
          a['destination'] = a.address;
          break;
        case 'Phone':
        case 'Text':
          a['destination'] = a.phoneNumber;
          break;
        case 'Email':
          a['destination'] = '';
          break;
      }
    });
  }
}
